import { createContext } from 'react';
import { StepWizardContextProps } from './StepWizard.types';

export const StepWizardContext = createContext<StepWizardContextProps>(
  {} as StepWizardContextProps
);
